import { Container, Reveal } from '@/components/common'
import { usePageTitle } from '@/hooks'

const sections = [
  {
    heading: 'Introduction',
    body: [
      'These Terms of Use govern your access to and use of the IBON World website. By using this website, you agree to these terms.',
    ],
  },
  {
    heading: 'Use of This Website',
    body: [
      'You may browse and use this website for lawful, personal, and informational purposes related to our mission. You agree not to misuse the website, attempt to disrupt its operation, or access it through unauthorised means.',
    ],
  },
  {
    heading: 'Intellectual Property',
    body: [
      'All content on this website, including text, images, logos, and design, is the property of IBON World or its licensors and is protected by applicable intellectual property laws. You may not reproduce or redistribute this content without our permission.',
    ],
  },
  {
    heading: 'User Conduct',
    body: [
      'When contacting us or submitting information through this website, you agree to provide accurate information and not to submit content that is unlawful, harmful, or infringes on the rights of others.',
    ],
  },
  {
    heading: 'Third-Party Links',
    body: [
      'This website may contain links to third-party websites, including social media and payment platforms. We are not responsible for the content, accuracy, or practices of those external sites.',
    ],
  },
  {
    heading: 'Disclaimer',
    body: [
      'This website and its content are provided "as is" without warranties of any kind. While we strive for accuracy, we do not guarantee that all information on this site is complete, current, or error-free.',
    ],
  },
  {
    heading: 'Limitation of Liability',
    body: [
      'To the fullest extent permitted by law, IBON World shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website.',
    ],
  },
  {
    heading: 'Changes to These Terms',
    body: [
      'We may update these Terms of Use from time to time. Continued use of the website after changes are posted constitutes acceptance of the updated terms.',
    ],
  },
  {
    heading: 'Contact Us',
    body: [
      'If you have questions about these Terms of Use, please reach out via our Contact page.',
    ],
  },
]

export const TermsPage = () => {
  usePageTitle('Terms of Use')

  return (
    <>
      <section className="bg-ibon-dark py-24 lg:py-32">
        <Container>
          <Reveal variant="up" delay={100}>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-ibon-sky">Legal</p>
            <h1 className="mt-4 text-4xl font-bold leading-[1.03] tracking-[-0.02em] text-white sm:text-5xl">
              Terms of Use
            </h1>
            <p className="mt-4 text-sm text-white/50">Last updated: August 2026</p>
          </Reveal>
        </Container>
      </section>

      <section className="bg-white py-20 lg:py-28">
        <Container>
          <div className="mx-auto max-w-3xl space-y-14">
            {sections.map(({ heading, body }) => (
              <div key={heading}>
                <h2 className="text-2xl font-bold tracking-tight text-ibon-dark">{heading}</h2>
                <div className="mt-4 space-y-4">
                  {body.map((paragraph) => (
                    <p key={paragraph} className="text-base leading-relaxed text-text-muted">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  )
}
